import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Header from '../Components/Header';

const AddBanner = () => {
    const [imageBase64, setImageBase64] = useState(""); 
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    // Convert selected file to Base64
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = () => {
                setImageBase64(reader.result); 
                console.log("Converted Base64:", reader.result);
            };
        }
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!imageBase64) {
            alert("Please select an image!");
            return;
        }
    
        setLoading(true);
        try {
            // console.log("Sending Data:", { image: imageBase64 });
    
            const response = await axios.post(
                "https://www.aatheshsoft.com/admin_api/banner_add.php",
                { image: imageBase64 },
                
                { headers: { 
                    "Content-Type": "application/json", 
                    "Accept": "application/json" } 
                }
            );
    
            // console.log("API Response:", response.data);
    
            if (response.data?.head?.code === 200) {
                alert("Banner added successfully!");
                navigate("/bannerlist");
            } else {
                alert("Error: " + (response.data?.head?.msg || "Unexpected API response"));
            }
        } catch (error) {
            console.error("API Error:", error);
            alert("Something went wrong! Please try again.");
        } finally {
            setLoading(false);
        }
    };
    

    return (
        <>
            <Header />
            <div className="page-wrapper compact-wrapper" id="pageWrapper">
                <div className="page-body-wrapper">
                    <div className="page-body">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="row">
                                        <div className="col-sm-12 m-auto">
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="title-header option-title d-sm-flex d-block">
                                                        <h5>Add Banner Images</h5>
                                                        <div className="right-options">
                                                            <ul>
                                                                <li>
                                                                    <Link className="btn btn-solid" to="/bannerlist">Back</Link>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>

                                                    <form className="theme-form theme-form-2 mega-form" onSubmit={handleSubmit}>
                                                        <div className="mb-4 row align-items-center">
                                                            <label className="form-label-title col-sm-3 mb-0">Upload Image</label>
                                                            <div className="col-sm-9">
                                                                <input 
                                                                    className="form-control form-choose" 
                                                                    type="file" 
                                                                    accept="image/*"
                                                                    onChange={handleFileChange} 
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="card-footer border-0 pb-0 d-flex justify-content-end">
                                                            <button type="submit" className="btn btn-primary me-3" disabled={loading}>
                                                                {loading ? "Uploading..." : "Submit"}
                                                            </button>
                                                            <button type="button" className="btn btn-outline" onClick={() => navigate("/bannerlist")}>Cancel</button>
                                                        </div>
                                                    </form>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default AddBanner;
